import * as angular from 'angular';
import { takeUntil } from 'rxjs/operators';

import { DataViewTypes, ProducerTypes } from '@mode/shared/contract-common';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';
import { DataViewFacade } from '@mode/switch-views/contract';
import { MixableBaseController } from '~/common/component';
import { buildViewDetailsUiSref } from '../../routes/routing-helpers';

class ReportBrowserController extends MixableBaseController implements angular.IOnInit {
  static $inject = ['DataViewFacade', 'ThoughtspotIntegrationService'];

  accountId: string;
  runIdUrlParam: string;
  readonly googleSheetType = ProducerTypes.GoogleSheet;
  private datasets: DataViewTypes.EnhancedDatasetResult[];
  private thoughtspotIntegrated$ = this.thoughtspotIntegrationService.currOrgIntegrated$;
  readonly producerTypes = ProducerTypes;

  constructor(
    private dataViewFacade: DataViewFacade,
    private thoughtspotIntegrationService: ThoughtspotIntegrationService
  ) {
    super();
  }

  $onInit(): void {
    this.dataViewFacade.enhancedDatasetResults$.pipe(takeUntil(this.destroyed$)).subscribe((datasetResults) => {
      this.datasets = datasetResults;
    });
  }

  processQueryName(name: string): string {
    return name ? name : 'Query';
  }

  processQueryRunStateResults(state: string): string {
    if (state === 'cancelled' || state === 'failed') {
      return 'warning';
    }
    if (state === 'running' || state === 'enqueued') {
      return 'refresh';
    }
    return '';
  }

  buildUiSref(fragment: string, params: { [key: string]: any } = {}) {
    const hasRunId = typeof this.runIdUrlParam === 'string';
    if (hasRunId) {
      params = {
        ...params,
        runId: this.runIdUrlParam,
      };
    }
    return buildViewDetailsUiSref(fragment, hasRunId, params);
  }
}

export const ID = 'reportBrowser';

export const reportBrowser: angular.IComponentOptions = {
  template: `
    <div class="report-browser">
      <h3 class="sidebar-title">Report</h3>
      <div class="browser-list">
        <div ng-if="!(ctrl.thoughtspotIntegrated$ | async:this)">
          <a ui-sref="^.dashboard" class="view-report-link">
            View Report
          </a>
        </div>
        <div>
          <a ui-sref=".details" ui-sref-active="active"  class="browser-item">
            <capra-icon icon="icon-details" title="Details"></capra-icon>
            <span class="query-name">Details</span>
          </a>
        </div>
        <div ng-if="!(ctrl.thoughtspotIntegrated$ | async:this)">
          <a ui-sref=".presentation" ui-sref-active="active"  class="browser-item">
            <capra-icon icon="icon-html" title="HTML"></capra-icon>
            <span class="query-name">HTML</span>
          </a>
        </div>
        <div>
          <a ui-sref=".detailsNotebook" ui-sref-active="active"  class="browser-item">
            <capra-icon icon="icon-notebook-generic" title="Notebook"></capra-icon>
            <span class="query-name"> Notebook</span>
          </a>
        </div>
        </div>
        <hr class="divider" />
        <h3 class="sidebar-title">DATA</h3>
        <div class="browser-list">
          <div ng-repeat="dataset in ctrl.datasets | orderByNatural: 'displayName'">
            <div class="item-header">
              <capra-icon class="is-dataset local-dataset" ng-if="dataset.isLocal && dataset.producerType === ctrl.producerTypes.NotebookCell" icon="icon-dataset" title="dataset"></capra-icon>
              <capra-icon class="is-dataset" ng-if="!dataset.isLocal" icon="icon-dataset" title="dataset"></capra-icon>
              <capra-icon ng-if="dataset.isLocal && !dataset.isMetric && dataset.producerType !== ctrl.producerTypes.NotebookCell" icon="icon-sql" title="query"></capra-icon>
              <capra-icon ng-if="dataset.isLocal && dataset.isMetric" icon="icon-metrics" title="metric"></capra-icon>
              <span ng-if="dataset.isLocal" class="query-header" title="{{ctrl.processQueryName(dataset.displayName)}}">{{ctrl.processQueryName(dataset.displayName)}}</span>
              <a ng-if="!dataset.isLocal" class="query-header datasets" href="./{{ctrl.accountId}}/datasets/{{dataset.datasetToken}}" target="_blank">{{ctrl.processQueryName(dataset.displayName)}}
                <capra-icon class="navigate-to-source-icon" icon="icon-new-tab"  title="dataset"></capra-icon>
              </a>
            </div>
            <div class="sub-browser-list">
              <div>
                <a ui-sref=".detailsQuery({ queryId: dataset.queryToken })" ui-sref-active="active">
                  <span>Source {{ dataset.producerType === ctrl.googleSheetType ? 'file' : 'code' }}</span>
                </a>
              </div>
              <div>
                <a ui-sref=".detailsDataset({ queryId: dataset.queryToken })" ui-sref-active="active" class="result-item">
                 <span> Data </span>
                  <capra-icon class="warning-icon" ng-if="ctrl.processQueryRunStateResults(dataset.queryRunState) === 'warning'" icon="icon-warning" title="Warning"></capra-icon>
                  <mode-animated-refresh-icon  class="status-icon" ng-if="ctrl.processQueryRunStateResults(dataset.queryRunState) === 'refresh'"></mode-animated-refresh-icon>
                </a>
              </div>
            </div>
          </div>
      </div>
    </div>
  `,
  controller: ReportBrowserController,
  controllerAs: 'ctrl',
  bindings: {
    accountId: '<',
    runIdUrlParam: '<?',
  },
};
